<template>
  <div class="ic-form__phone">
    <IcFormRowWrapper
      id="phone"
      name="phone"
      :label="$t('label_phone')"
      :aria="$t('aria_required')"
      :labelWidth="4"
      :controlWidth="8"
      :showSingleError="true"
    >
      <template slot-scope="{validator}">
        <IcInputPhone id="phone" autocomplete="tel-national" v-model="data.phone" @input="emitInput(data.phone,validator)"></IcInputPhone>
      </template>
    </IcFormRowWrapper>
  </div>
</template>

<script>
import IcInputPhone from "@/components/ic-common/form/controls/InputPhone";
import { emitInput } from "./mixins";

export default {
  name: "IcFormContactPhone",
  props: {
    value: {
      type: String,
      default: ""
    },
    agreement: {
      type: [Number, Boolean],
      default: 0
    },
    withAgreement: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: {
        phone: this.value
      }
    };
  },
  methods: {
    emitInput
  },
  components: {
    IcInputPhone
  }
};
</script>

<style>
</style>
